<template>
  <!-- 页面主体区域 -->
  <div>
    <main>
      <!-- 背景1 -->
      <div class="bg1">
        <!-- <img v-lazy="require('./imgs/bg1.png')" alt="" class="bg11" /> -->
        <img :src="tygjx1.bgImg" alt="" class="bg11" />
        <img src="" alt="" />
        <span class="gjx">{{ tygjx1.title }}</span>
        <span class="hyzy">{{ tygjx1.subtitle }}</span>
        <el-button @click="showdlg" round class="ljgd" style="border-style:none"
          >加入我们</el-button
        >
      </div>
      <imgss :imgarr="imgarr" :auto="auto"></imgss>
      <!-- 详情页 -->
      <!-- table栏目切换 -->

      <!-- <div
    style="
    background-color:#1b1c20 ;
    height:10px;
    margin-top:10px">
    </div> -->
      <!-- 背景1 -->
      <!-- 背景2 -->
      <div class="bg2">
        <div v-html="tygjxxqy1" class="zhgjx2"></div>
      </div>
      <tabless :tablearr="tablearr"></tabless>
      <!-- 对话框 -->
      <div class="dilog" v-show="showdia">
        <div class="close" @click="closedel"></div>
        <div class="imgtop"></div>
        <div class="imgleft"></div>
        <div class="textone">加入我们</div>
        <div class="texttwo">CONTACT US</div>
        <div class="callwe">
          <img src="./imgs/userwe.png" class="users" title="联系人" />

          <div class="texts">周骏飞</div>
          <img src="./imgs/usertel.png" alt="" title="联系电话" class="tel" />
          <div class="texts">18013886200</div>
        </div>
      </div>
      <div class="mocks" v-show="showdia" @click="closedlgs"></div>
      <!-- 背景2 -->
      <!-- 页面主体区域 -->
      <Header></Header>
      <Footer></Footer>
    </main>
  </div>
</template>

<script>
import { getlag, getpages, getimgs, gettables } from "@/api/srapi/srapi.js";
// table
import tabless from "@/views/srdemo/component/table.vue";
//img
import imgss from "@/views/srdemo/component/img.vue";
//引入头部组件
import { getTygjx, getTygjxxqy } from "@/api/wslapi/";
import Header from "@/components/Header.vue";
// 引入底部组件
import Footer from "@/components/Footer.vue";
export default {
  watch: {
    showdia() {
      this.auto = this.showdia;
    },
  },
  created() {
    this.tygjx();
    this.tygjxxqy();
  },
  mounted() {
    // console.log( this.$route.query.id);

    //获取页面的全部数据
    this.getallpages();
    //获取轮播图片
    this.getimgss();
    //获取table图片
    this.gettabless();
  },
  components: {
    Header,
    Footer,
    tabless,
    imgss,
  },
  data() {
    return {
      auto: false,
      tygjx1: [],
      showdia: false,
      tygjxxqy1: [],
      //轮播图得数据
      imgarr: [],
      //table得数据
      tablearr: [],
      //当前激活得table
      clicktableimg: 0,
    };
  },
  methods: {
    async getallpages() {
      const res = await getlag("20e1a958-524d-4f0e-8407-31289732cae7");
      this.bandat = res.data.data;
      //  console.log(res.data.data);
      //  console.log(res.data.data.pcUrl);
      const pages = await getpages(res.data.data.pcUrl);
      this.pagetable = pages.data.content;
    },
    //获取轮播图
    async getimgss() {
      const res = await getimgs("5f29d361-ff1e-4b76-8be5-6cc953bf7a9d");
      // console.log("imgs");
      res.data.data.banners.map((item) => {
        if (item.bannerImg) {
          this.imgarr.push(item);
        }
      });
      // console.log(this.imgarr);
    },
    //获取table图片
    async gettabless() {
      const res = await gettables("5f29d361-ff1e-4b76-8be5-6cc953bf7a9d");
      res.data.data.tabs.map((item) => {
        if (item.tabImg) {
          this.tablearr.push(item);
        }
        // console.log(this.tablearr);
      });
    },

    tygjxxqy() {
      getTygjxxqy().then((res) => {
        this.tygjxxqy1 = res.data.content;
        // console.log(res.data.content);
      });
    },
    tygjx() {
      getTygjx().then((res) => {
        this.tygjx1 = res.data.data;
        // console.log(res.data.data);
      });
    },
    showdlg() {
      this.showdia = true;
    },
    closedel() {
      this.showdia = false;
    },
    closedlgs() {
      this.closedel();
    },
  },
};
</script>

<style lang="scss" scoped>
.dilog {
  z-index: 20;
  width: 544px;
  height: 320px;
  position: absolute;
  left: 700px;
  top: 374px;
  background: url("./imgs/dlog.png") no-repeat center;
  background-size: 100% 100%;
  .imgtop {
    width: 148px;
    height: 120px;
    background: url("./imgs/hetop.png") no-repeat center;
    background-size: 100% 100%;
    position: absolute;
    right: -40px;
    top: -21px;
  }
  .imgleft {
    width: 156px;
    height: 118px;
    background: url("./imgs/heleft.png") no-repeat center;
    background-size: 100% 100%;
    position: absolute;
    left: -44px;
    bottom: -2px;
  }
  .textone {
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #856959;
    line-height: 24px;
    margin-top: 101px;
    margin-bottom: 14px;
  }
  .texttwo {
    font-size: 16px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #856959;
    letter-spacing: 2px;
  }
  .callwe {
    margin-top: 47px;
    padding-left: 85px;
    display: flex;
    position: absolute;
    .users {
      width: 24px;
      height: 24px;
    }
    .tel {
      width: 24px;
      height: 24px;

      margin-left: 120px;
    }
    .texts {
      margin-left: 20px;
      font-size: 18px;
      font-weight: 400;
      color: #856959;
    }
  }
  .close {
    width: 25px;
    height: 24px;
    background: url("./imgs/closeone.png") no-repeat center;
    background-size: 100% 100%;
    position: absolute;
    top: -35px;
    right: -24px;
    z-index: 5;
  }
  .close:hover {
    cursor: pointer;
  }
}
.mocks {
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0.5;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
}
.bg1 {
  // min-width: 1920px;
  height: 600px;
  // background: url(./imgs/bg1.png);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  img[lazy="loading"] {
    width: 200px;
    height: 200px;
  }
  // 实际图片大小
  img[lazy="loaded"] {
    height: 600px;
    width: 100%;
  }
  .bg11 {
    height: 600px;
    width: 100%;
  }
  .gjx {
    min-width: 361px;
    height: 67px;
    font-size: 48px;

    font-weight: 500;
    color: #ffffff;
    line-height: 67px;

    text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.3);
    position: absolute;
    top: 229.9968px;
    left: 300px;
  }
  .hyzy {
    min-width: 360px;
    height: 33px;
    font-size: 24px;

    font-weight: 400;
    color: #ffffff;
    line-height: 33px;
    text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.3);
    position: absolute;
    top: 321.0048px;
    left: 360px;
  }
  .ljgd {
    min-width: 168px;
    font-size: 20px;
    height: 48px;
    background: #007aff;
    border-radius: 24px;
    position: absolute;
    top: 394.0032px;
    left: 360px;
    color: #ffffff;
  }
}
.bg2 {
  // min-width: 1920px;
  height: 2100px;
  background: #ffffff;
  position: relative;
  left: -100px;
  .zhgjx2 {
    position: absolute;
    left: 60px;
  }
  .ykfw {
    min-width: 167px;
    height: 56px;
    font-size: 40px;

    font-weight: 400;
    color: #333333;
    line-height: 56px;
    letter-spacing: 1px;
    position: absolute;
    top: 80px;
    left: 875.0016px;
  }
  .flbt1 {
    min-width: 157px;
    height: 63px;
    background: #007aff;
    box-shadow: 0px 0px 8px 2px rgba(0, 122, 255, 0.48);
    border-radius: 4px;
    position: absolute;
    top: 176px;
    left: 360px;
    .font1 {
      min-width: 68px;
      height: 22px;
      font-size: 16px;

      font-weight: 500;
      color: #ffffff;
      line-height: 22px;
      position: absolute;
      top: 20px;
      left: 45px;
    }
  }
  .flbt2 {
    min-width: 157px;
    height: 63px;
    border-radius: 4px;
    border: 1px solid #e6e6e6;
    position: absolute;
    top: 176px;
    left: 532px;
    .font2 {
      min-width: 68px;
      height: 22px;
      font-size: 16px;

      font-weight: 400;
      color: #666666;
      line-height: 22px;
      position: absolute;
      top: 20px;
      left: 45px;
    }
  }
  .flbt3 {
    min-width: 157px;
    height: 63px;
    border-radius: 4px;
    border: 1px solid #e6e6e6;
    position: absolute;
    top: 176px;
    left: 707px;
    .font3 {
      min-width: 68px;
      height: 22px;
      font-size: 16px;

      font-weight: 400;
      color: #666666;
      line-height: 22px;
      position: absolute;
      top: 20px;
      left: 45px;
    }
  }
  .flbt4 {
    min-width: 157px;
    height: 63px;
    border-radius: 4px;
    border: 1px solid #e6e6e6;
    position: absolute;
    top: 176px;
    left: 881px;
    .font4 {
      min-width: 68px;
      height: 22px;
      font-size: 16px;

      font-weight: 400;
      color: #666666;
      line-height: 22px;
      position: absolute;
      top: 20px;
      left: 45px;
    }
  }
  .flbt5 {
    min-width: 157px;
    height: 63px;
    border-radius: 4px;
    border: 1px solid #e6e6e6;
    position: absolute;
    top: 176px;
    left: 1055px;
    .font5 {
      min-width: 68px;
      height: 22px;
      font-size: 16px;

      font-weight: 400;
      color: #666666;
      line-height: 22px;
      position: absolute;
      top: 20px;
      left: 45px;
    }
  }
  .flbt6 {
    min-width: 157px;
    height: 63px;
    border-radius: 4px;
    border: 1px solid #e6e6e6;
    position: absolute;
    top: 176px;
    left: 1229px;
    .font6 {
      min-width: 68px;
      height: 22px;
      font-size: 16px;

      font-weight: 400;
      color: #666666;
      line-height: 22px;
      position: absolute;
      top: 20px;
      left: 45px;
    }
  }
  .flbt7 {
    min-width: 157px;
    height: 63px;
    border-radius: 4px;
    border: 1px solid #e6e6e6;
    position: absolute;
    top: 176px;
    left: 1403px;
    .font7 {
      min-width: 68px;
      height: 22px;
      font-size: 16px;

      font-weight: 400;
      color: #666666;
      line-height: 22px;
      position: absolute;
      top: 20px;
      left: 45px;
    }
  }
  .icon1 {
    min-width: 278px;
    height: 316px;
    background: #ffffff;
    box-shadow: 2px 4px 12px 2px rgba(0, 0, 0, 0.04);
    position: absolute;
    top: 269px;
    left: 361px;
    .image1 {
      min-width: 76px;
      height: 76px;
      position: absolute;
      top: 48px;
      left: 102px;
    }
    .jqmp {
      min-width: 84px;
      height: 28px;
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      position: absolute;
      top: 148px;
      left: 99px;
      text-align: left;
    }
    .fh1 {
      width: 210px;
      height: 60px;
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      position: absolute;
      top: 192px;
      left: 36px;
      text-align: left;
    }
  }
  .icon2 {
    min-width: 278px;
    height: 316px;
    background: #ffffff;
    box-shadow: 2px 4px 12px 2px rgba(0, 0, 0, 0.04);
    position: absolute;
    top: 269px;
    left: 669px;
    .image2 {
      width: 76px;
      height: 76px;
      position: absolute;
      top: 48px;
      left: 102px;
    }
    .zndh {
      min-width: 84px;
      height: 28px;
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      position: absolute;
      top: 148px;
      left: 99px;
    }
    .fh2 {
      width: 210px;
      height: 60px;
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      position: absolute;
      top: 192px;
      left: 36px;
      text-align: left;
    }
  }
  .icon3 {
    min-width: 278px;
    height: 316px;
    background: #ffffff;
    box-shadow: 2px 4px 12px 2px rgba(0, 0, 0, 0.04);
    position: absolute;
    top: 269px;
    left: 977px;
    .image3 {
      min-width: 76px;
      height: 76px;
      position: absolute;
      top: 48px;
      left: 102px;
    }
    .tqzs {
      min-width: 84px;
      height: 28px;
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      position: absolute;
      top: 148px;
      left: 99px;
      text-align: left;
    }
    .fh3 {
      width: 210px;
      height: 60px;
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      position: absolute;
      top: 192px;
      left: 36px;
      text-align: left;
    }
  }
  .icon4 {
    min-width: 278px;
    height: 316px;
    background: #ffffff;
    box-shadow: 2px 4px 12px 2px rgba(0, 0, 0, 0.04);
    position: absolute;
    top: 269px;
    left: 1285px;
    .image4 {
      min-width: 76px;
      height: 76px;
      position: absolute;
      top: 48px;
      left: 102px;
    }
    .cyfw {
      min-width: 84px;
      height: 28px;
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      position: absolute;
      top: 148px;
      left: 99px;
      text-align: left;
    }
    .fh4 {
      width: 210px;
      height: 60px;
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      position: absolute;
      top: 192px;
      left: 36px;
      text-align: left;
    }
  }
  .icon5 {
    min-width: 278px;
    height: 316px;
    background: #ffffff;
    box-shadow: 2px 4px 12px 2px rgba(0, 0, 0, 0.04);
    position: absolute;
    top: 615px;
    left: 360px;
    .image5 {
      min-width: 76px;
      height: 76px;
      position: absolute;
      top: 48px;
      left: 102px;
    }
    .hdbm {
      min-width: 84px;
      height: 28px;
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      position: absolute;
      top: 148px;
      left: 99px;
      text-align: left;
    }
    .fh5 {
      width: 210px;
      height: 60px;
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      position: absolute;
      top: 192px;
      left: 36px;
      text-align: left;
    }
  }
  .icon6 {
    min-width: 278px;
    height: 316px;
    background: #ffffff;
    box-shadow: 2px 4px 12px 2px rgba(0, 0, 0, 0.04);
    position: absolute;
    top: 615px;
    left: 668px;
    .image6 {
      min-width: 76px;
      height: 76px;
      position: absolute;
      top: 48px;
      left: 102px;
    }
    .zsfw {
      min-width: 84px;
      height: 28px;
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      position: absolute;
      top: 148px;
      left: 99px;
      text-align: left;
    }
    .fh6 {
      width: 210px;
      height: 60px;
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      position: absolute;
      top: 192px;
      left: 36px;
      text-align: left;
    }
  }
  .icon7 {
    min-width: 278px;
    height: 316px;
    background: #ffffff;
    box-shadow: 2px 4px 12px 2px rgba(0, 0, 0, 0.04);
    position: absolute;
    top: 615px;
    left: 976px;
    .image7 {
      min-width: 76px;
      height: 76px;
      position: absolute;
      top: 48px;
      left: 102px;
    }
    .mzb {
      min-width: 84px;
      height: 28px;
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      position: absolute;
      top: 148px;
      left: 99px;
      text-align: left;
    }
    .fh7 {
      width: 210px;
      height: 60px;
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      position: absolute;
      top: 192px;
      left: 36px;
      text-align: left;
    }
  }
  .icon8 {
    min-width: 278px;
    height: 316px;
    background: #ffffff;
    box-shadow: 2px 4px 12px 2px rgba(0, 0, 0, 0.04);
    position: absolute;
    top: 615px;
    left: 1284px;
    .image8 {
      min-width: 76px;
      height: 76px;
      position: absolute;
      top: 48px;
      left: 102px;
    }
    .fsyy {
      min-width: 84px;
      height: 28px;
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      position: absolute;
      top: 148px;
      left: 99px;
      text-align: left;
    }
    .fh8 {
      width: 210px;
      height: 60px;
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      position: absolute;
      top: 192px;
      left: 36px;
      text-align: left;
    }
  }
  .icon9 {
    min-width: 278px;
    height: 316px;
    background: #ffffff;
    box-shadow: 2px 4px 12px 2px rgba(0, 0, 0, 0.04);
    position: absolute;
    top: 961px;
    left: 360px;
    .image9 {
      min-width: 76px;
      height: 76px;
      position: absolute;
      top: 48px;
      left: 102px;
    }
    .ds {
      min-width: 84px;
      height: 28px;
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      position: absolute;
      top: 148px;
      left: 120px;
      text-align: left;
    }
    .fh9 {
      width: 210px;
      height: 60px;
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      position: absolute;
      top: 192px;
      left: 36px;
      text-align: left;
    }
  }
  .icon10 {
    min-width: 278px;
    height: 316px;
    background: #ffffff;
    box-shadow: 2px 4px 12px 2px rgba(0, 0, 0, 0.04);
    position: absolute;
    top: 961px;
    left: 668px;
    .image10 {
      min-width: 76px;
      height: 76px;
      position: absolute;
      top: 48px;
      left: 102px;
    }
    .pw {
      min-width: 84px;
      height: 28px;
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      position: absolute;
      top: 148px;
      left: 99px;
      text-align: left;
    }
    .fh10 {
      width: 210px;
      height: 60px;
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      position: absolute;
      top: 192px;
      left: 36px;
      text-align: left;
    }
  }
  .icon11 {
    min-width: 278px;
    height: 316px;
    background: #ffffff;
    box-shadow: 2px 4px 12px 2px rgba(0, 0, 0, 0.04);
    position: absolute;
    top: 961px;
    left: 976px;
    .image11 {
      min-width: 76px;
      height: 76px;
      position: absolute;
      top: 48px;
      left: 102px;
    }
    .zbsc {
      min-width: 84px;
      height: 28px;
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      position: absolute;
      top: 148px;
      left: 88px;
      text-align: left;
    }
    .fh11 {
      width: 210px;
      height: 60px;
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      position: absolute;
      top: 192px;
      left: 36px;
      text-align: left;
    }
  }
  .icon12 {
    min-width: 278px;
    height: 316px;
    background: #ffffff;
    box-shadow: 2px 4px 12px 2px rgba(0, 0, 0, 0.04);
    position: absolute;
    top: 961px;
    left: 1284px;
    .image12 {
      min-width: 76px;
      height: 76px;
      position: absolute;
      top: 48px;
      left: 102px;
    }
    .znsbhc {
      min-width: 84px;
      height: 28px;
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      position: absolute;
      top: 148px;
      left: 88px;
      text-align: left;
    }
    .fh12 {
      width: 210px;
      height: 60px;
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      position: absolute;
      top: 192px;
      left: 36px;
      text-align: left;
    }
  }
  .icon13 {
    min-width: 278px;
    height: 316px;
    background: #ffffff;
    box-shadow: 2px 4px 12px 2px rgba(0, 0, 0, 0.04);
    position: absolute;
    top: 1307px;
    left: 360px;
    .image13 {
      min-width: 76px;
      height: 76px;
      position: absolute;
      top: 48px;
      left: 102px;
    }
    .znfy {
      min-width: 84px;
      height: 28px;
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      position: absolute;
      top: 148px;
      left: 88px;
      text-align: left;
    }
    .fh13 {
      width: 210px;
      height: 60px;
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      position: absolute;
      top: 192px;
      left: 36px;
      text-align: left;
    }
  }
  .icon14 {
    min-width: 278px;
    height: 316px;
    background: #ffffff;
    box-shadow: 2px 4px 12px 2px rgba(0, 0, 0, 0.04);
    position: absolute;
    top: 1307px;
    left: 669px;
    .image14 {
      min-width: 76px;
      height: 76px;
      position: absolute;
      top: 48px;
      left: 102px;
    }
    .tsjpj {
      min-width: 84px;
      height: 28px;
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      position: absolute;
      top: 148px;
      left: 99px;
      text-align: left;
    }
    .fh14 {
      width: 210px;
      height: 60px;
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      position: absolute;
      top: 192px;
      left: 36px;
      text-align: left;
    }
  }
  .icon15 {
    min-width: 278px;
    height: 316px;
    background: #ffffff;
    box-shadow: 2px 4px 12px 2px rgba(0, 0, 0, 0.04);
    position: absolute;
    top: 1307px;
    left: 977px;
    .image15 {
      min-width: 76px;
      height: 76px;
      position: absolute;
      top: 48px;
      left: 102px;
    }
    .jkm {
      min-width: 84px;
      height: 28px;
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      position: absolute;
      top: 148px;
      left: 99px;
      text-align: left;
    }
    .fh15 {
      width: 210px;
      height: 60px;
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      position: absolute;
      top: 192px;
      left: 36px;
      text-align: left;
    }
  }
  .icon16 {
    min-width: 278px;
    height: 316px;
    background: #ffffff;
    box-shadow: 2px 4px 12px 2px rgba(0, 0, 0, 0.04);
    position: absolute;
    top: 1307px;
    left: 1285px;
    .image16 {
      min-width: 76px;
      height: 76px;
      position: absolute;
      top: 48px;
      left: 102px;
    }
    .swdt {
      min-width: 84px;
      height: 28px;
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      position: absolute;
      top: 148px;
      left: 99px;
      text-align: left;
    }
    .fh16 {
      width: 210px;
      height: 60px;
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      position: absolute;
      top: 192px;
      left: 36px;
      text-align: left;
    }
  }
  .icon17 {
    min-width: 278px;
    height: 316px;
    background: #ffffff;
    box-shadow: 2px 4px 12px 2px rgba(0, 0, 0, 0.04);
    position: absolute;
    top: 1653px;
    left: 361px;
    .image17 {
      min-width: 76px;
      height: 76px;
      position: absolute;
      top: 48px;
      left: 102px;
    }
    .gdfw {
      min-width: 84px;
      height: 28px;
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      position: absolute;
      top: 148px;
      left: 68px;
      text-align: left;
    }
    .fh17 {
      width: 206px;
      height: 60px;
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      position: absolute;
      top: 192px;
      left: 36px;
      text-align: center;
    }
  }
}
.bg3 {
  height: 243px;
  position: relative;
  .image2 {
    min-width: 359px;
    height: 47px;
    position: absolute;
    top: 100px;
    left: 711px;
  }
  .lhcp {
    width: 132px;
    height: 45px;
    font-size: 32px;
    color: #333333;
    position: absolute;
    top: 100px;
    left: 1081px;
  }
}
// 5 对话
/deep/.el-dialog {
  width: 35% !important;
  margin-top: 300px !important;
  .el-dialog__body {
    padding-top: 24px;
  }
  text-align: center;
  div {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.6);
  }
  .twotext {
    margin-top: 8px;
  }
}
</style>
